import { useState } from "react";
import ImportarConfigLocalModal from "./ImportarConfigLocalModal";
import "../primerUso/primerUso.css";

/**
 * "Copiar configuración de otro local", shown at the start of the guided first run (creation only).
 * `importado` is what the flow kept of the last copy (`origen`, `avisos`): after copying, the notice
 * tells what to review and that photos are uploaded again. `onImport(config)` fills the flow's data.
 */
const ImportarConfigLocal = ({ tipo, importado, onImport }) => {
  const [abierto, setAbierto] = useState(false);

  return (
    <div className="pu-import">
      {importado ? (
        <div className="ef-alert ef-alert--info pu-import__notice" role="status">
          <div>
            Copiaste la configuración de <b>{importado.origen || "otro local"}</b>. Revisala en cada paso, cambiá el nombre
            y subí las fotos de nuevo: las imágenes no se copian.
          </div>
          {importado.avisos?.length > 0 && (
            <ul>
              {importado.avisos.map((a) => (
                <li key={a}>{a}</li>
              ))}
            </ul>
          )}
        </div>
      ) : null}
      <button type="button" className="ef-btn ef-btn--outline" onClick={() => setAbierto(true)}>
        {importado ? "Copiar de otro local" : "Copiar configuración de otro local"}
      </button>
      {abierto && (
        <ImportarConfigLocalModal
          tipo={tipo}
          onClose={() => setAbierto(false)}
          onImport={(config) => {
            onImport(config);
            setAbierto(false);
          }}
        />
      )}
    </div>
  );
};

export default ImportarConfigLocal;
